// --- 助手组件：图片画廊 ---
// 示例图片数组 - 你可以在这里添加更多图片
// 方式1: 从 assets 导入（需要先 import）
// import exampleImage from '../assets/my-image.png';

function ImageGallery() {
  // 示例图片数据 - 你可以修改这个数组来添加你的图片
  const galleryImages = [
    {
      id: 1,
      // 方式1: 使用 assets 中的图片（需要先在上面 import）
      // src: exampleImage,
      // 方式2: 使用 public 目录中的图片（直接写路径）
      src: '/sample-images/image1.jpg',
      alt: '示例图片 1',
      className: 'lg:col-span-2'
    },
    {
      id: 2,
      src: '/sample-images/image2.jpg',
      alt: '示例图片 2',
      className: ''
    },
    {
      id: 3,
      src: '/sample-images/image3.jpg',
      alt: '示例图片 3',
      className: 'lg:row-span-2 lg:aspect-[9/16]'
    },
    {
      id: 4,
      src: '/sample-images/image4.jpg',
      alt: '示例图片 4',
      className: ''
    },
    {
      id: 5,
      src: '/sample-images/image5.jpg',
      alt: '示例图片 5',
      className: ''
    },
    {
      id: 6,
      src: '/sample-images/image6.jpg',
      alt: '示例图片 6',
      className: ''
    },
    {
      id: 7,
      src: '/sample-images/image7.jpg',
      alt: '示例图片 7',
      className: 'lg:col-span-2'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 auto-rows-auto">
      {galleryImages.map((image) => (
        <div
          key={image.id}
          className={`rounded-lg bg-black aspect-video overflow-hidden hover:opacity-90 transition-opacity cursor-pointer ${image.className}`}
        >
          <img
            src={image.src}
            alt={image.alt}
            className="w-full h-full object-cover"
            onError={(e) => {
              // 如果图片加载失败，显示占位背景
              e.target.style.display = 'none';
              e.target.parentElement.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
            }}
          />
        </div>
      ))}
    </div>
  );
}

export default ImageGallery;
